/**
 * `auto` — the auto-DJ pseudo-preset.
 *
 * This preset is registered like any other so it has a valid id, name, and
 * keyboard slot, but it's NEVER actually rendered. The engine intercepts
 * `loadPreset('auto')` (and `loadPresetAt(slot-of-auto)`) to enable the
 * `AutoCycler`, which immediately swaps the registry to a real child preset
 * and then sequences switches based on time + beat + audio energy.
 *
 * The params here are deliberately a clone of the Phase 0 reference: if
 * anything ever goes wrong and this preset *is* rendered, the user gets the
 * known-safe baseline rather than a crash or a black frame.
 */

import {
  PHASE0_SEED,
  PHASE0_WARP,
} from '../../phase0Reference';
import type { VisualizerPreset } from '../presetTypes';

export const AUTO_PRESET_ID = 'auto';

export const autoPreset: VisualizerPreset = {
  id: AUTO_PRESET_ID,
  name: 'Auto (random)',
  seed: { kind: 'waveform', params: { ...PHASE0_SEED } },
  warp: {
    kind: PHASE0_WARP.kind,
    params: {
      baseZoom: PHASE0_WARP.baseZoom,
      bassZoomGain: PHASE0_WARP.bassZoomGain,
      rotation: PHASE0_WARP.rotation,
      bassRotationGain: PHASE0_WARP.bassRotationGain,
      ripple: PHASE0_WARP.ripple,
      rippleFreq: PHASE0_WARP.rippleFreq,
      decay: PHASE0_WARP.decay,
      chroma: PHASE0_WARP.chroma,
      hueShift: PHASE0_WARP.hueShift,
      beatPunch: PHASE0_WARP.beatPunch,
      centerDriftAmp: PHASE0_WARP.centerDriftAmp,
      centerDriftRate: PHASE0_WARP.centerDriftRate,
    },
  },
  modulation: [],
  transition: { durationMs: 800 },
};
